/**
 * @flow
 */
import * as React from 'react';
import { Collapse, Navbar, NavbarToggler, Nav, NavItem, NavLink } from 'reactstrap';
import { Link, withRouter } from 'react-router';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import NavBrand from './NavBrand';

type Props = {
  onLangChanged: (lang: string) => void,
};

@observer
class HeaderComponent extends React.Component<Props, void> {
  @observable isOpen: boolean = false;

  toggle = () => {
    this.isOpen = !this.isOpen;
  };

  render() {
    const { props: { router } } = this;
    console.log('header', this.props);
    const location = {
      pathname: '/analysis',
      state: this.props.location.state
    };
    
    return (
      <Navbar color="faded" className="d-print-none" light toggleable>
        <NavbarToggler right onClick={this.toggle} />
        <NavBrand />
        <Collapse isOpen={this.isOpen} navbar>
          <Nav navbar>
            {router.location.pathname !== '/analysis' && router.location.pathname !== '/' ? (
              <React.Fragment>
                <NavItem>
                  <NavLink tag={Link} to={location} activeClassName="active">
                    {'Zurück zu den Suchergebnissen'}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} to="/analysis" activeClassName="active">
                    {'Neue Suche'}
                  </NavLink>
                </NavItem>
              </React.Fragment>
            ) : null}
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}

const Header = withRouter(HeaderComponent);
export default Header;


// WEBPACK FOOTER //
// ./src/App/Layout/Header/index.js